import React, { useState, useEffect } from "react";
import "./Alert.scss";
export type color = "warning" | "success" | "danger";
export interface Props {
  alertId?: any;
  customClass?: any;
  showAlrt?: boolean;
  alertType?: color;
  alertTitle?: string;
  alertContent?: string;
  alertIcon?: any;
}
const Alert = ({
  customClass,
  alertId,
  showAlrt,
  alertType = "success",
  alertTitle,
  alertContent,
  alertIcon,
}: Props) => {
  const [showA, setShowA] = useState(showAlrt);
  const closeAlert = () => {
    setShowA(!showA);
  };
  return (
    <>
      {showA !== false && showAlrt && (
        <div
          className={`mfg-alert${
            customClass ? " " + customClass : ""
          } alert-${alertType}`}
          id={alertId}
          role="alert"
        >
          <div className="alert-content">
            {alertIcon && <img src={alertIcon} alt={alertType} />}
            <div className="alrtCont">
              {alertTitle && <h3>{alertTitle}</h3>}
              <p>{alertContent}</p>
            </div>
          </div>
          <button className="alrtClose" onClick={closeAlert}>X</button>
        </div>
      )}
    </>
  );
};

export default Alert;
